module.exports = __webpack_public_path__ + "static/media/file-spreadsheet.8f658a39.svg";